import React from 'react';

const Helpsupports = () => {
  return (
    <div className="max-w-4xl p-6">
      <h1 className="text-3xl font-bold mb-4">Help & Support</h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">How can we help you?</h2>
        <p>If you have any questions, feel free to reach out. We're here to help!</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Common Questions</h2>
        <ul className="list-disc list-inside">
          <li>How do I reset my password?</li>
          <li>How do I contact customer support?</li>
          <li>What payment methods do you accept?</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Contact Us</h2>
        <p>If you need further assistance, you can reach us at:</p>
        <ul className="list-none">
          <li>WhatsApp: <a href="https://wa.me/628118787220" className="text-blue-600">+628118787220</a></li>
          <li>Email: <a href="mailto:henry.mth@mudahtechnology.com" className="text-blue-600">henry.mth@mudahtechnology.com</a></li>
        </ul>
      </section>

      <footer className="mt-8 text-gray-600 text-sm">
        <p>© 2024 PT. Teknologi Mudah Selaras. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Helpsupports;
